// -----------------------------------------------------------------
// CustomeSpecific: Supports Conventional Cipher
// -----------------------------------------------------------------
import { Buffer } from 'buffer'
import CustomCrypto from './CustomCrypto'
// -----------------------------------------------------------------
//
// -----------------------------------------------------------------
// -----------------------------------------------------------------
// pbkdf1() : Internal Use
// -----------------------------------------------------------------
async function pbkdf1 (
  password,
  salt,
  iterationCount,
  keyLength,
  hashAlgorithm
) {
  // console.log('CustomeSpecific.pbkdf1():ENTER')
  // console.log('CustomeSpecific.pbkdf1():password=' + password)
  // console.log('CustomeSpecific.pbkdf1():salt=' + salt)
  // console.log('CustomeSpecific.pbkdf1():iterationCount=' + iterationCount)
  // console.log('CustomeSpecific.pbkdf1():keyLength=' + keyLength)
  // console.log('CustomeSpecific.pbkdf1():hashAlgorithm=' + hashAlgorithm)

  const buffer = Buffer.concat([password, salt])
  let key = new ArrayBuffer(buffer)
  for (let i = 0; i < iterationCount; i++) {

    const temp = await crypto.subtle.digest(hashAlgorithm, key)
    key = new Uint8Array(temp)
    // key = CustomCrypto.createHash(hashAlgorithm).update(key).digest();
  }
  // console.log('CustomeSpecific.pbkdf1():key=' + key)
  // console.log('CustomeSpecific.pbkdf1():LEAVE')
  return key.slice(0, keyLength)
}
// -----------------------------------------------------------------
// makePKCS12B2Key() : Internal Use
// -----------------------------------------------------------------
async function makePKCS12B2Key (
  hashAlgorithm,
  keyLength,
  password,
  salt,
  iterationCount,
  id) {
  // console.log('CustomeSpecific.makePKCS12B2Key():ENTER')
  // console.log('CustomeSpecific.makePKCS12B2Key():hashAlgorithm=' + hashAlgorithm)
  // console.log('CustomeSpecific.makePKCS12B2Key():keyLength=' + keyLength)
  // console.log('CustomeSpecific.makePKCS12B2Key():password=' + PKIUtils.ary2str(password))
  // console.log('CustomeSpecific.makePKCS12B2Key():salt=' + PKIUtils.ary2hex(salt))
  // console.log('CustomeSpecific.makePKCS12B2Key():iterationCount=' + iterationCount)
  // console.log('CustomeSpecific.makePKCS12B2Key():id=' + id)
  // Check input "method" value
  if ((typeof id === 'undefined')) {
    id = 3 // For MACing
  }

  // Initial variables
  let u
  let v

  const result = []

  // Get "u" and "v" values
  switch (hashAlgorithm.toUpperCase()) {
    case 'SHA-1':
      u = 20 // 160
      v = 64 // 512
      break
    case 'SHA-256':
      u = 32 // 256
      v = 64 // 512
      break
    case 'SHA-384':
      u = 48 // 384
      v = 128 // 1024
      break
    case 'SHA-512':
      u = 64 // 512
      v = 128 // 1024
      break
    default:
      throw new Error('Unsupported hashing algorithm')
  }

  // Main algorithm making key
  // Transform password to UTF-8 like string
  const passwordViewInitial = new Uint8Array(password)
  const passwordTransformed = new ArrayBuffer((password.byteLength * 2) + 2)
  const passwordTransformedView = new Uint8Array(passwordTransformed)

  for (let i = 0; i < passwordViewInitial.length; i++) {
    passwordTransformedView[i * 2] = 0x00
    passwordTransformedView[i * 2 + 1] = passwordViewInitial[i]
  }

  passwordTransformedView[passwordTransformedView.length - 2] = 0x00
  passwordTransformedView[passwordTransformedView.length - 1] = 0x00

  password = passwordTransformed.slice(0)

  // Construct a string D (the "diversifier") by concatenating v/8 copies of ID
  const D = new ArrayBuffer(v)
  const dView = new Uint8Array(D)

  for (let i = 0; i < D.byteLength; i++) {
    dView[i] = id // The ID value equal to "3" for MACing (see B.3 of standard)
  }

  // Concatenate copies of the salt together to create a string S of length v * ceil(s / v) bytes (the final copy of the salt may be trunacted to create S)
  const saltLength = salt.byteLength

  const sLen = v * Math.ceil(saltLength / v)
  const S = new ArrayBuffer(sLen)
  const sView = new Uint8Array(S)

  const saltView = new Uint8Array(salt)

  for (let i = 0; i < sLen; i++) {
    sView[i] = saltView[i % saltLength]
  }

  // Concatenate copies of the password together to create a string P of length v * ceil(p / v) bytes (the final copy of the password may be truncated to create P)
  const passwordLength = password.byteLength

  const pLen = v * Math.ceil(passwordLength / v)
  const P = new ArrayBuffer(pLen)
  const pView = new Uint8Array(P)

  const passwordView = new Uint8Array(password)

  for (let i = 0; i < pLen; i++) {
    pView[i] = passwordView[i % passwordLength]
  }

  // Set I=S||P to be the concatenation of S and P
  const sPlusPLength = S.byteLength + P.byteLength

  let I = new ArrayBuffer(sPlusPLength)
  let iView = new Uint8Array(I)

  iView.set(sView)
  iView.set(pView, sView.length)

  // Set c=ceil(n / u)
  const c = Math.ceil((keyLength >> 3) / u)

  // For i=1, 2, ..., c, do the following:
  for (let i = 0; i <= c; i++) {
    // Create contecanetion of D and I
    const dAndI = new ArrayBuffer(D.byteLength + I.byteLength)
    const dAndIView = new Uint8Array(dAndI)

    dAndIView.set(dView)
    dAndIView.set(iView, dView.length)

    // Make "iterationCount" rounds of hashing
    // let roundBuffer = Buffer.from(dAndI);
    let roundBuffer = new Uint8Array(dAndIView)
    try {
      // console.log("CustomeSpecific.makePKCS12B2Key():roundBuffer=" + PKIUtils.ary2hex(roundBuffer));
      for (let j = 0; j < iterationCount; j++) {
        // const hash = CustomCrypto.createHash(hashAlgorithm);
        // hash.update(roundBuffer);
        // roundBuffer = hash.digest();

        const temp = await crypto.subtle.digest(hashAlgorithm, roundBuffer)
        roundBuffer = new Uint8Array(temp)
        // console.log("CustomeSpecific.makePKCS12B2Key():roundBuffer=" + roundBuffer);
      }
    } catch (e) {
      // console.log('CustomeSpecific.makePKCS12B2Key():Error=' + e)
      throw new Error(e)
    }
    // console.log("CustomeSpecific.makePKCS12B2Key():roundBuffer=" + PKIUtils.ary2hex(roundBuffer));

    // Concatenate copies of Ai to create a string B of length v bits (the final copy of Ai may be truncated to create B)
    const B = new ArrayBuffer(v)
    const bView = new Uint8Array(B)
    for (let j = 0; j < B.byteLength; j++) {
      bView[j] = roundBuffer[j % roundBuffer.length]
    }

    // Make new I value
    const k = Math.ceil(saltLength / v) + Math.ceil(passwordLength / v)
    const iRound = []

    let sliceStart = 0
    let sliceLength = v

    for (let j = 0; j < k; j++) {
      const chunk = Array.from(new Uint8Array(I.slice(sliceStart, sliceStart + sliceLength)))
      sliceStart += v
      if ((sliceStart + v) > I.byteLength) {
        sliceLength = I.byteLength - sliceStart
      }
      let x = 0x1ff
      for (let l = (B.byteLength - 1); l >= 0; l--) {
        x = x >> 8
        x += bView[l] + chunk[l]
        chunk[l] = (x & 0xff)
      }
      iRound.push(...chunk)
    }

    I = new ArrayBuffer(iRound.length)
    iView = new Uint8Array(I)
    iView.set(iRound)

    result.push(...roundBuffer)
  }

  // Initialize final key
  const resultBuffer = new ArrayBuffer(keyLength >> 3)
  const resultView = new Uint8Array(resultBuffer)
  resultView.set((new Uint8Array(result)).slice(0, keyLength >> 3))
  // console.log('CustomeSpecific.makePKCS12B2Key():LEAVE')

  return Buffer.from(resultBuffer)
}

// -----------------------------------------------------------------
// getRandomValues
// -----------------------------------------------------------------
export function getRandomValues (length) {
  // return (new Uint8Array(crypto.randomBytes(length))); For Node
  // console.log('CustomeSpecific.getRandomValues():ENTER')
  var array = new Uint8Array(length)

  var result = crypto.getRandomValues(array)
  // console.log('CustomeSpecific.getRandomValues():result(' + length + ')=' + PKIUtils.ary2hex(result))
  // console.log('CustomeSpecific.getRandomValues():LEAVE')
  return result
}

// -----------------------------------------------------------------
// encryptUsingPBKDF2Password
// -----------------------------------------------------------------
export async function encryptUsingPBKDF2Password (
  algorithm,
  keyLength,
  password,
  salt,
  iterationCount,
  hashAlgorithm,
  iv,
  messageToEncrypt) {
  // console.log('CustomeSpecific.encryptUsingPBKDF2Password():ENTER')

  // Derive raw key bytes using PBKDF2 via Web Crypto API (browser-compatible)
  const passwordKey = await crypto.subtle.importKey(
    'raw',
    Buffer.from(password),
    { name: 'PBKDF2' },
    false,
    ['deriveBits']
  )

  const derivedBits = await crypto.subtle.deriveBits(
    {
      name: 'PBKDF2',
      salt: Buffer.from(salt),
      iterations: iterationCount,
      hash: hashAlgorithm
    },
    passwordKey,
    keyLength * 8
  )

  const key = new Uint8Array(derivedBits)
  const ivBuffer = Buffer.from(iv)

  // AES-CBC variants: use Web Crypto API
  if (algorithm === 'AES-256-CBC' || algorithm === 'AES-128-CBC') {
    const aesKey = await crypto.subtle.importKey('raw', key, { name: 'AES-CBC' }, false, ['encrypt'])
    const encrypted = await crypto.subtle.encrypt({ name: 'AES-CBC', iv: ivBuffer }, aesKey, Buffer.from(messageToEncrypt))
    // console.log('CustomeSpecific.encryptUsingPBKDF2Password():LEAVE')
    return encrypted
  }

  // DES-EDE3-CBC and others: delegate to Forge via CustomCrypto.encrypt
  // console.log('CustomeSpecific.encryptUsingPBKDF2Password():LEAVE')
  return CustomCrypto.encrypt(algorithm, key, ivBuffer, messageToEncrypt)
}
// -----------------------------------------------------------------
// decryptUsingPBKDF2Password
// -----------------------------------------------------------------
export function decryptUsingPBKDF2Password (
  algorithm,
  keyLength,
  password,
  salt,
  iterationCount,
  hashAlgorithm,
  iv,
  messageToDecrypt) {
  // console.log('CustomeSpecific.decryptUsingPBKDF2Password():ENTER')
  // Initial variables
  let cipher

  // Derive key using PBKDF2 algorithm

  const key = CustomCrypto.pbkdf2Sync(Buffer.from(password), Buffer.from(salt), iterationCount, keyLength, hashAlgorithm)

  // Initialize cipher object
  if (iv.byteLength) {

    cipher = CustomCrypto.createDecipheriv(algorithm, key, Buffer.from(iv))
  } else {
    cipher = CustomCrypto.createDecipher(algorithm, key)
  }
  // console.log('CustomeSpecific.decryptUsingPBKDF2Password():LEAVE')

  return (new Uint8Array(Buffer.concat([cipher.update(Buffer.from(messageToDecrypt)), cipher.final()]))).buffer
}

// -----------------------------------------------------------------
// encryptUsingPBKDF1Password
// -----------------------------------------------------------------
export async function encryptUsingPBKDF1Password (
  algorithm,
  keyLength,
  ivLength,
  password,
  salt,
  iterationCount,
  messageToEncrypt,
  method) {
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():ENTER')
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():algorithm=' + algorithm)
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():keyLength=' + keyLength)
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():ivLength=' + ivLength)
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():password=' + PKIUtils.ary2str(password))
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():salt=' + PKIUtils.ary2hex(salt))
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():iterationCount=' + iterationCount)
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():messageToEncrypt=' + messageToEncrypt)
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():method=' + method)
  // Check input "method" value
  if ((typeof method === 'undefined')) {
    method = 'pkcs12'
  }

  // Initial variables
  let key
  let iv

  // Generate key and IV using selected generation method
  switch (method.toLowerCase()) {
    // PKCS#12 key derivation function
    case 'pkcs12':
      key = await makePKCS12B2Key('SHA-1', keyLength << 3, password, salt, iterationCount, 1)
      // console.log('CustomeSpecific.encryptUsingPBKDF1Password():key=' + PKIUtils.ary2hex(key))
      iv = await makePKCS12B2Key('SHA-1', ivLength << 3, password, salt, iterationCount, 2)
      // console.log('CustomeSpecific.encryptUsingPBKDF1Password():iv=' + PKIUtils.ary2hex(iv))
      break
    // PKCS#5 key derivation function
    default:
      // eslint-disable-next-line no-case-declarations
      const pbkdf1Result = await pbkdf1(Buffer.from(password), Buffer.from(salt), iterationCount, 16, 'SHA-1')
      key = pbkdf1Result.slice(0, 8)
      iv = pbkdf1Result.slice(8)
      break
  }

  // Initialize cipher object
  // const cipher = await CustomCrypto.createCipheriv(algorithm, key, iv);
  // let result = (new Uint8Array(Buffer.concat([cipher.update(Buffer.from(messageToEncrypt)), cipher.final()]))).buffer;
  const result = await CustomCrypto.encrypt(algorithm, key, iv, messageToEncrypt)
  // console.log('CustomeSpecific.encryptUsingPBKDF1Password():LEAVE')
  return result
}

// -----------------------------------------------------------------
// decryptUsingPBKDF1Password
// -----------------------------------------------------------------
export async function decryptUsingPBKDF1Password (
  algorithm,
  keyLength,
  ivLength,
  password,
  salt,
  iterationCount,
  messageToDecrypt,
  method) {
  // console.log('CustomeSpecific.decryptUsingPBKDF1Password():ENTER')
  // Check input "method" value
  if ((typeof method === 'undefined')) {
    method = 'pkcs12'
  }

  // Initial variables
  let key
  let iv

  // Generate key and IV using selected generation method
  switch (method.toLowerCase()) {
    // PKCS#12 key derivation function
    case 'pkcs12':
      key = await makePKCS12B2Key('SHA-1', keyLength << 3, password, salt, iterationCount, 1)
      iv = await makePKCS12B2Key('SHA-1', ivLength << 3, password, salt, iterationCount, 2)
      break
    // PKCS#5 key derivation function
    default:
      // eslint-disable-next-line no-case-declarations
      const pbkdf1Result = await pbkdf1(Buffer.from(password), Buffer.from(salt), iterationCount, 16, 'SHA-1')
      key = pbkdf1Result.slice(0, 8)
      iv = pbkdf1Result.slice(8)
      break
  }

  // Initialize cipher object
  const cipher = CustomCrypto.createDecipheriv(algorithm, key, iv)
  // console.log('CustomeSpecific.decryptUsingPBKDF1Password():LEAVE')

  return (new Uint8Array(Buffer.concat([cipher.update(Buffer.from(messageToDecrypt)), cipher.final()]))).buffer
}

// -----------------------------------------------------------------
// stampDataWithPassword
// Making MAC data using algorithm described in B.2 of PKCS#12 standard.
// -----------------------------------------------------------------
export async function stampDataWithPassword (
  hashAlgorithm,
  keyLength,
  password,
  salt,
  iterationCount,
  stampingData,
  method) {
  // console.log('CustomeSpecific.stampDataWithPassword():ENTER')
  // Initial variables
  let key

  // Check input "method" value
  if ((typeof method === 'undefined')) {
    method = 'pkcs12'
  }

  // Derive key using PKCS#12 algorithm from B.2 item of standard
  switch (method.toLowerCase()) {
    case 'pbkdf2':

      key = CustomCrypto.pbkdf2Sync(Buffer.from(password), Buffer.from(salt), iterationCount, keyLength, hashAlgorithm)
      break
    case 'pkcs12':
    default:
      key = await makePKCS12B2Key(hashAlgorithm, keyLength, password, salt, iterationCount, 3)
      break
  }

  // Making HMAC value
  // const hmac = CustomCrypto.createHmac(hashAlgorithm, key);
  // hmac.update(Buffer.from(stampingData));
  // let result = (new Uint8Array(hmac.digest())).buffer;
  const result = await CustomCrypto.calcHmac(hashAlgorithm, key, stampingData)
  // console.log('CustomeSpecific.stampDataWithPassword():LEAVE')
  return result
}

// -----------------------------------------------------------------
// verifyDataStampedWithPassword
// -----------------------------------------------------------------
export async function verifyDataStampedWithPassword (
  hashAlgorithm,
  keyLength,
  password,
  salt,
  iterationCount,
  stampedData,
  signatureToVerify,
  method) {
  // console.log('CustomeSpecific.verifyDataStampedWithPassword():ENTER')
  // Initial variables
  let key

  // Check input "method" value
  if ((typeof method === 'undefined')) {
    method = 'pkcs12'
  }

  // Derive key using PKCS#12 algorithm from B.2 item of standard
  switch (method.toLowerCase()) {
    case 'pbkdf2':

      key = CustomCrypto.pbkdf2Sync(Buffer.from(password), Buffer.from(salt), iterationCount, keyLength, hashAlgorithm)
      break
    case 'pkcs12':
    default:
      key = await makePKCS12B2Key(hashAlgorithm, keyLength, password, salt, iterationCount, 3)
  }

  // Making HMAC value
  const hmac = CustomCrypto.createHmac(hashAlgorithm, key)

  hmac.update(Buffer.from(stampedData))
  const hmacValue = new Uint8Array(hmac.digest())

  // Compare HMAC digest with signature to verify
  const dataView = new Uint8Array(signatureToVerify)

  if (hmacValue.length !== dataView.length) {
    return false
  }
  let result = true

  for (let i = 0; i < hmacValue.length; i++) {
    if (hmacValue[i] !== dataView[i]) {
      result = false
      break
    }
  }
  // console.log('CustomeSpecific.verifyDataStampedWithPassword():LEAVE')
  return result
}
